import { MobileBaseObject } from './mobile-base-object';
import { List } from "immutable";

export interface IGpsLocation extends MobileBaseObject {
  gpsId: string;
  longitude: number;
  latitude: number;
  time: Date;
  altitude: number;
  speed: number;
  userMappingId: string;
}


export class GpsLocation extends MobileBaseObject implements IGpsLocation {

  public gpsId: string;
  public longitude: number;
  public latitude: number;
  public time: Date;
  public altitude: number;
  public speed: number;
  public userMappingId: string;

  public constructor(
    gpsLocation: Partial<IGpsLocation>

  ) {
    super();

    this.gpsId = gpsLocation.gpsId;   // different id than base Id?
    this.longitude = gpsLocation.longitude;
    this.latitude = gpsLocation.latitude;
    this.time = new Date(gpsLocation.time);
    this.altitude = gpsLocation.altitude;
    this.speed = gpsLocation.speed;
    this.userMappingId = gpsLocation.userMappingId;

    this.id = gpsLocation.id;
    this.version = gpsLocation.version;
    this.createdAt = gpsLocation.createdAt;
    this.updatedAt = gpsLocation.updatedAt;
    this.version = gpsLocation.version;
  }

}
